var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { API_PATH } from "../../constants";
import { action, observable, runInAction, makeObservable } from "mobx";
import { getAxios } from '../../backend';
import { EventName } from "@whatsper/texterchat-common";
import { pick } from "lodash";
class LabelsStore {
    constructor(rootStore) {
        Object.defineProperty(this, "rootStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "labels", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: observable([])
        });
        Object.defineProperty(this, "loading", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "labelsFetched", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "fetchLabels", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => __awaiter(this, void 0, void 0, function* () {
                runInAction(() => {
                    this.loading = true;
                });
                yield getAxios()
                    .then((axios) => {
                    return axios.get(API_PATH.LABELS);
                })
                    .then(({ data }) => {
                    runInAction(() => {
                        this.labels.replace(data.labels);
                        this.labelsFetched = true;
                    });
                })
                    .catch(error => console.error("ERROR: getting labels failed", error))
                    .finally(() => {
                    runInAction(() => {
                        this.loading = false;
                    });
                });
            })
        });
        Object.defineProperty(this, "createLabel", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (labelProps) => __awaiter(this, void 0, void 0, function* () {
                yield getAxios()
                    .then((axios) => {
                    return axios.post(API_PATH.LABELS, labelProps);
                });
            })
        });
        Object.defineProperty(this, "editLabel", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (label) => __awaiter(this, void 0, void 0, function* () {
                yield getAxios()
                    .then((axios) => {
                    return axios.patch(`${API_PATH.LABELS}/${label.id}`, pick(label, ['name', 'color']));
                });
            })
        });
        Object.defineProperty(this, "deleteLabel", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (id) => __awaiter(this, void 0, void 0, function* () {
                yield getAxios()
                    .then((axios) => {
                    return axios.delete(`${API_PATH.LABELS}/${id}`);
                });
            })
        });
        makeObservable(this);
        this.rootStore = rootStore;
        this.rootStore.events
            .addListener(EventName.label_created, (data) => this.onLabelCreatedEvent(data))
            .addListener(EventName.label_renamed, (data) => this.onLabelRenamedEvent(data))
            .addListener(EventName.label_color_changed, (data) => this.onLabelColorChangedEvent(data))
            .addListener(EventName.label_deleted, (data) => this.onLabelDeletedEvent(data));
    }
    getLabelData(id) {
        return this.labels.find(lbl => lbl.id === id);
    }
    onLabelCreatedEvent(eventData) {
        this.labels.push(eventData.label);
    }
    onLabelRenamedEvent(eventData) {
        this.labels.replace(this.labels.map((lbl) => {
            return eventData.label.id === lbl.id ? eventData.label : lbl;
        }));
    }
    onLabelColorChangedEvent(eventData) {
        this.labels.replace(this.labels.map((lbl) => {
            return eventData.label.id === lbl.id ? eventData.label : lbl;
        }));
    }
    onLabelDeletedEvent(eventData) {
        this.labels.replace(this.labels.filter((lbl) => lbl.id !== eventData.label.id));
    }
}
__decorate([
    observable
], LabelsStore.prototype, "loading", void 0);
__decorate([
    observable
], LabelsStore.prototype, "labelsFetched", void 0);
__decorate([
    action
], LabelsStore.prototype, "onLabelCreatedEvent", null);
__decorate([
    action
], LabelsStore.prototype, "onLabelRenamedEvent", null);
__decorate([
    action
], LabelsStore.prototype, "onLabelColorChangedEvent", null);
__decorate([
    action
], LabelsStore.prototype, "onLabelDeletedEvent", null);
export default LabelsStore;
